import { render, staticRenderFns } from "./SelectionParams.vue?vue&type=template&id=27d91468&scoped=true"
import script from "./SelectionParams.vue?vue&type=script&lang=js"
export * from "./SelectionParams.vue?vue&type=script&lang=js"
import style0 from "./SelectionParams.vue?vue&type=style&index=0&id=27d91468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d91468",
  null
  
)

export default component.exports